<div class="edit-email" [hidden]="isLoading">
  <div class="mb mat-elevation-z8">
    <h1>Potwierdzanie zmiany adresów email...</h1>
  </div>
</div>
